/* Filenames in SHOWCASE/ - used by the landing page peek grid and marquee.
   Numbers are 1-based, left-to-right then top-to-bottom on each peek page (6 per page desktop). */

const SHOWCASE_BY_NUMBER = {
  1: "SHOWCASE/BATHROOM CLEAR MIRROR - DAY.webp",
  2: "SHOWCASE/ENTRY HALL NO GLASS NO DOOR - NIGHT LIGHTS ON.webp",
  3: "SHOWCASE/EXT. BEACH FOOD TRUCK - DAY.webp",
  4: "SHOWCASE/EXT. BOOK STORE STREET - DAY.webp",
  5: "SHOWCASE/EXT. BRICK CONDO - DAY.webp",
  6: "SHOWCASE/EXT. FARMERS MARKET.webp",
  7: "SHOWCASE/EXT. KOREAN RESTAURANT - DAY.webp",
  8: "SHOWCASE/EXT. MOTEL VENDING MACHINE - DAY.webp",
  9: "SHOWCASE/HOTEL ROOM - NIGHT.webp",
  10: "SHOWCASE/INT. BAKERY WITH WINDOW - DAY.webp",
  11: "SHOWCASE/INT. BOHO APRTMNT GIRL'S BEDROOM - NIGHT.webp",
  12: "SHOWCASE/INT. CLUB BAR COUNTER.webp",
  13: "SHOWCASE/INT. COUNTRYSIDE HOUSE BATHROOM.webp",
  14: "SHOWCASE/INT. INDUSTRIAL LOFT KITCHEN.webp",
  15: "SHOWCASE/INT. JUDGE TABLE.webp",
  16: "SHOWCASE/INT. MALL MAG & SNACK KIOSK.webp",
  17: "SHOWCASE/INT. PASTEL COFFEE SHOP.webp",
  18: "SHOWCASE/INT. PENTHOUSE OFFICE - DAY.webp",
  19: "SHOWCASE/INT. PINK-TEAL RETRO DINER.webp",
  20: "SHOWCASE/INT. ROYAL CASTLE BLUE BATHROOM - NIGHT.webp",
  21: "SHOWCASE/INT. ROYAL CASTLE BLUE BEDROOM - DAY.webp",
  22: "SHOWCASE/INT. ROYAL CASTLE LIBRARY CHAIRS - DAY.webp",
  23: "SHOWCASE/INT. ROYAL CASTLE OFFICE - DAY.webp",
  24: "SHOWCASE/INT. SPACEY HALLWAY.webp",
  25: "SHOWCASE/INT. WALK-THROUGH OFFICE - DAY.webp",
  26: "SHOWCASE/INT. WHITE PENTHOUSE MASTER BEDROOM - DAY.webp",
  27: "SHOWCASE/OFFICE SAFE OPEN - SUNSET.webp",
  28: "SHOWCASE/1.png",
  29: "SHOWCASE/2.png",
  30: "SHOWCASE/3.png",
};

/** Peek grid order (6 per page on desktop). Edit this list to reshuffle pages. */
export const SHOWCASE_ORDER = [
  /* page 1 */ 1, 12, 14, 17, 21, 24,
  /* page 2 */ 5, 2, 4, 10, 11, 7,
  /* page 3 */ 8, 18, 13, 16, 9, 20,
  /* page 4 */ 28, 29, 30, 25, 26, 27,
  /* page 5 */ 3, 15, 6, 22, 19, 23,
];

export const SHOWCASE_IMAGES = SHOWCASE_ORDER.map((n) => SHOWCASE_BY_NUMBER[n]);
